export default function isCAAS(siteId) {
  return siteId >= 100000;
}
